import { Button } from '@ui/lib/park/ui/button';
import { Slider } from '@ui/lib/park/ui/slider';
import { Text } from '@ui/lib/park/ui/text';
import { HStack, Stack } from 'styled-system/jsx';

import { labelStyle, valueStyle } from './styles';

const CLOSE_QTY_PERCENT_MARKS = [25, 50, 75, 100];

export const CloseQtyPercentageSelector = ({
  value,
  onChange,
  mt = '3',
  flush = false,
}: {
  value: number;
  onChange: (value: number) => void;
  mt?: string;
  /** editor-modal spec: group sits flush on the panel under a hairline rule */
  flush?: boolean;
}) => {
  return (
    <Stack
      mt={mt}
      p={flush ? '0' : '3'}
      pt={flush ? '3' : '3'}
      gap="3"
      border={flush ? 'none' : '1px solid'}
      borderColor="v2.border.default"
      borderTop={flush ? '1px solid' : undefined}
      borderTopColor={flush ? 'v2.border.hairline' : undefined}
      borderRadius={flush ? '0' : '4px'}
      bg={flush ? 'transparent' : 'v2.bg.surface1'}
    >
      <HStack justifyContent="space-between">
        <Text css={labelStyle}>Close Qty %</Text>
        <Text css={valueStyle}>{Math.round(value)}%</Text>
      </HStack>
      <Slider
        size="sm"
        colorPalette="sliderLeverage"
        min={1}
        max={100}
        step={1}
        value={[value]}
        onValueChange={(details) => onChange(details.value[0] ?? 100)}
        tooltip={{
          isEnabled: true,
          renderContent: (nextValue) => `${Math.round(nextValue)}%`,
        }}
      />
      {/* V2 preset chips: equal-width, selected = long-dim tint */}
      <HStack gap="6px" mt="1">
        {CLOSE_QTY_PERCENT_MARKS.map((percent) => {
          const selected = Math.round(value) === percent;

          return (
            <Button
              key={percent}
              variant="secondary"
              size="xsmall"
              flex="1"
              h="26px"
              borderRadius="2px"
              fontFamily="Inter"
              fontWeight={500}
              bg={selected ? 'v2.long.dim' : 'v2.bg.surface2'}
              borderColor={selected ? 'v2.long.border' : 'v2.border.default'}
              color={selected ? 'v2.long.default' : 'v2.text.muted'}
              _hover={{ bg: selected ? 'v2.long.dim' : 'v2.bg.hover' }}
              onClick={() => onChange(percent)}
            >
              {percent}%
            </Button>
          );
        })}
      </HStack>
    </Stack>
  );
};
